import type { MarqueeScope } from '@/components/canvas/workspace/controllers/marqueeSelectUtils';
import type { SliceDeps } from '../deps';

export function createSelectionSlice({ set }: SliceDeps) {
  return {
    selectElement: (id: string, addToSelection: boolean) => {
      set((state) => ({
        isPageSelected: false,
        selectedPageIds: [],
        selectedBlockIds: [],
        selectionScope: null,
        selectedElementIds: addToSelection
          ? state.selectedElementIds.includes(id)
            ? state.selectedElementIds.filter((x) => x !== id)
            : [...state.selectedElementIds, id]
          : [id],
      }));
    },

    selectElements: (ids: string[], scope?: MarqueeScope | null) =>
      set({
        selectedElementIds: ids,
        selectedBlockIds: [],
        isPageSelected: false,
        selectedPageIds: [],
        selectionScope:
          ids.length === 0 ? null : scope !== undefined ? scope : ('page' as MarqueeScope),
      }),

    selectMarqueeResult: (payload: {
      elementIds: string[];
      pageIds: string[];
      scope: MarqueeScope;
    }) =>
      set({
        selectedElementIds: payload.elementIds,
        selectedBlockIds: [],
        selectedPageIds: payload.pageIds,
        selectionScope: payload.scope,
        isPageSelected: false,
      }),

    selectBlock: (id: string, addToSelection = false) => {
      set((state) => ({
        isPageSelected: false,
        selectedPageIds: [],
        selectedElementIds: [],
        selectionScope: null,
        editingTextId: null,
        editingGroupId: null,
        selectedBlockIds: addToSelection
          ? state.selectedBlockIds.includes(id)
            ? state.selectedBlockIds.filter((x) => x !== id)
            : [...state.selectedBlockIds, id]
          : [id],
      }));
    },

    selectPageFrame: () =>
      set({
        selectedElementIds: [],
        selectedBlockIds: [],
        isPageSelected: true,
        selectedPageIds: [],
        selectionScope: null,
        selectedTableColumn: null,
        selectedTableRow: null,
        selectedTableCells: null,
        editingTableCellId: null,
        
        editingTextId: null,
        editingGroupId: null,
      }),

    clearSelection: () =>
      set({
        selectedElementIds: [],
        selectedBlockIds: [],
        isPageSelected: false,
        selectedPageIds: [],
        selectionScope: null,
        selectedTableColumn: null,
        selectedTableRow: null,
        selectedTableCells: null,
        editingTableCellId: null,
        
      }),

    /** 退出编辑器或预览时清空表格子选/编辑会话（不改动元素级选中） */
    clearTableSession: () =>
      set({
        selectedTableColumn: null,
        selectedTableRow: null,
        selectedTableCells: null,
        editingTableCellId: null,
        
      }),

    /** 点击工作区空白：取消激活页，保留工作区为操作目标 */
    deactivateCurrentPage: () =>
      set({
        currentPageId: '',
        isPageSelected: false,
        selectedElementIds: [],
        selectedBlockIds: [],
        selectedPageIds: [],
        selectionScope: null,
        selectedTableColumn: null,
        selectedTableRow: null,
        selectedTableCells: null,
        editingTableCellId: null,
        
        editingTextId: null,
        editingGroupId: null,
      }),

    setSelectedTableColumn: (payload: { elementId: string; col: number } | null) =>
      set((s) => ({
        selectedTableColumn: payload,
        selectedTableRow:
          payload && s.selectedTableRow?.elementId === payload.elementId ? null : s.selectedTableRow,
        selectedTableCells:
          payload && s.selectedTableCells?.elementId === payload.elementId ? null : s.selectedTableCells,
      })),

    setSelectedTableRow: (payload: { elementId: string; row: number } | null) =>
      set((s) => ({
        selectedTableRow: payload,
        selectedTableColumn:
          payload && s.selectedTableColumn?.elementId === payload.elementId ? null : s.selectedTableColumn,
        selectedTableCells:
          payload && s.selectedTableCells?.elementId === payload.elementId ? null : s.selectedTableCells,
      })),

    setSelectedTableCells: (
      payload: { elementId: string; r0: number; c0: number; r1: number; c1: number } | null,
    ) =>
      set((s) => ({
        selectedTableCells: payload,
        selectedTableColumn:
          payload && s.selectedTableColumn?.elementId === payload.elementId ? null : s.selectedTableColumn,
        selectedTableRow:
          payload && s.selectedTableRow?.elementId === payload.elementId ? null : s.selectedTableRow,
      })),

    setEditingTextId: (id: string | null) => set({ editingTextId: id }),
    setEditingTableCellId: (id: string | null) => set({ editingTableCellId: id }),
    setEditingGroupId: (id: string | null) => set({ editingGroupId: id }),
    setHoveredBlockId: (id: string | null) => set({ hoveredBlockId: id }),
  };
}
